export default "__VITE_ASSET__4j0BNj_4__"